import { Injectable } from '@angular/core';
import { Solicitante } from 'src/app/models/solictante';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICIOS } from 'src/app/config/config';
import 'rxjs/add/operator/map';

@Injectable({
  providedIn: 'root'
})
export class TablasolicitanteService {
  solicitante: Solicitante;

  constructor(
    public http: HttpClient
  ) { }


  getLicencias(nombreusuario: string) {
 var url: string;
    if (nombreusuario!="BotAdmin") {  //  BotAdmoin es una palabra clave escrita en el alias d ela base de datos q identifica al asignador
      // en caso de que entre cualqueir usuario que no sea BotAdmin
      // aqui mostrara todos las solicitudes que entran al sistema
  url = URL_SERVICIOS + '/solicitante/pagados';
    return this.http.get ( url )

    .map ( (resp: any) => resp.solicitante);
    } else {
      // en caso de que sea BotAdmin el sistema mostrara aquellas solicitudes que no se le hayan asignado claves de usuarios
      url = URL_SERVICIOS + '/solicitante/botadmin';
      return this.http.get ( url )
  
      .map ( (resp: any) => resp.solicitante);
    }
   

  }

}
